var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"debug"},[(!_vm.static)?_c('el-button',{attrs:{"size":"mini","icon":"pf-icon bx bx-bug-alt icon mr"},on:{"click":_vm.toggle}},[_vm._v("Debug")]):_vm._e(),(!_vm.collapsed || _vm.static)?_c('pre',[_c('code',{domProps:{"textContent":_vm._s(_vm.json)}})]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }